export default "__VITE_ASSET__121b92d0__"